class NBGift extends HTMLElement {
  constructor() {
    super();
    this.handleFocusTrap = this.handleFocusTrap.bind(this);
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.sendAsGiftButton = null;
    this.focusableElements = [];
    this.firstFocusable = null;
    this.lastFocusable = null;
    this.isOpen = false;
    this.initialize();
  }

  async initialize() {
    this.giftCards = await this.getGiftCardItems();
    this.addGiftCardRecipientListener(this.giftCards);
    // Setup focus trap listeners
    this.setupFocusTrap();
  }

  setupFocusTrap() {
    // Find the trigger button outside the popup
    this.sendAsGiftButton = document.querySelector('[js-gift-button]');
    if (this.sendAsGiftButton) {
      this.sendAsGiftButton.addEventListener('click', this.handleOpen);
    }
    // Find all close buttons inside the popup
    this.querySelectorAll('[js-gift-close]').forEach((btn) => {
      btn.addEventListener('click', this.handleClose);
    });
  }

  handleOpen() {
    // Wait for the section to be visible
    setTimeout(() => {
      this.isOpen = true;
      this.updateFocusableElements();
      // Focus the recipient name input if it exists
      const recipientNameInput = this.querySelector('#gift-recipient-name');
      if (recipientNameInput) {
        recipientNameInput.focus();
      } else if (this.firstFocusable) {
        this.firstFocusable.focus();
      }
      document.addEventListener('keydown', this.handleFocusTrap);
      // Set aria-hidden on background
      const cartDrawerContent = document.querySelector('.drawer__inner');
      if (cartDrawerContent) {
        cartDrawerContent.setAttribute('aria-hidden', 'true');
      }
    }, 100);
  }

  handleClose() {
    this.isOpen = false;
    document.removeEventListener('keydown', this.handleFocusTrap);
    // Remove aria-hidden from background
    const cartDrawerContent = document.querySelector('.drawer__inner');
    if (cartDrawerContent) {
      cartDrawerContent.removeAttribute('aria-hidden');
    }
    // Return focus to the trigger button
    if (this.sendAsGiftButton) {
      setTimeout(() => this.sendAsGiftButton.focus(), 100);
    }
  }

  updateFocusableElements() {
    // Only select visible elements
    this.focusableElements = Array.from(
      this.querySelectorAll(
        'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    ).filter((el) => el.offsetParent !== null);
    this.firstFocusable = this.focusableElements[0];
    this.lastFocusable = this.focusableElements[this.focusableElements.length - 1];
  }

  handleFocusTrap(e) {
    if (!this.isOpen) return;
    if (e.key === 'Tab') {
      this.updateFocusableElements();
      if (this.focusableElements.length === 0) return;
      if (e.shiftKey) {
        if (document.activeElement === this.firstFocusable) {
          e.preventDefault();
          this.lastFocusable.focus();
        }
      } else {
        if (document.activeElement === this.lastFocusable) {
          e.preventDefault();
          this.firstFocusable.focus();
        }
      }
    } else if (e.key === 'Escape') {
      this.handleClose();
      // Optionally, close the popup visually if needed
      const cartDrawer = this.closest('cart-drawer');
      if (cartDrawer) {
        cartDrawer.dataset.giftOpen = 'false';
      }
    }
  }

  async getGiftCardItems() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      const giftCardItems = cart.items.filter((item) => item.product_type === 'Gift Cards' || item.gift_card);
      return giftCardItems;
    } catch (error) {
      console.error('Error fetching cart items:', error);
      return [];
    }
  }

  createGiftCardInfoObject(giftCardInformation) {
    const giftCardInfoObject = {};
    giftCardInformation.forEach((element) => {
      const key = element.getAttribute('data-name');
      const value = element.value;
      giftCardInfoObject[key] = value;
    });
    return giftCardInfoObject;
  }

  addGiftCardRecipientListener(giftCards) {
    const giftCardRecipientElement = this.querySelector('[name="__shopify_send_gift_card_to_recipient"]');
    if (giftCardRecipientElement) {
      giftCardRecipientElement.addEventListener('change', (event) => {
        console.log('Gift card recipient option changed:', event.target.checked);

        const giftCardInformation = this.querySelectorAll('[data-name]');
        const giftCardInfoObject = this.createGiftCardInfoObject(giftCardInformation);

        for (const giftCard of giftCards) {
          fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              id: giftCard.key,
              properties: giftCardInfoObject,
            }),
          })
            .then((response) => response.json())
            .catch((error) => console.error('Error updating gift card:', error))
            .finally(() => {
              console.log('Gift card updated');
              console.log(this.getGiftCardItems());
            });
        }
      });
    } else {
      console.error('Gift card recipient element not found');
    }
  }
}

customElements.define('nb-gift', NBGift);
